import { render, staticRenderFns } from "./total.vue?vue&type=template&id=13a5c1d2&"
import script from "./total.vue?vue&type=script&lang=ts&"
export * from "./total.vue?vue&type=script&lang=ts&"
import style0 from "./total.vue?vue&type=style&index=0&id=13a5c1d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports